import React, { Component } from "react";
import SurveyList from "./SurveyList";
import { withRouter } from "react-router-dom";

class SurveyGestion extends Component {
	state = {
		status: 0,
	};

	handleStatusSelect = e => {
		this.setState({ status: e });
		//this.props.history.push("/survey")
	};
	render() {
		return (
			<SurveyList
				handleStatusSelect={this.handleStatusSelect}
				status={this.state.status}
			/>
		);
	}
}

export default withRouter(SurveyGestion);



// WEBPACK FOOTER //
// src/components/survey/gestion/SurveyGestion.js